import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=f78711be&scoped=true&"
import script from "./TransferModal.vue?vue&type=script&lang=js&"
export * from "./TransferModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferModal.vue?vue&type=style&index=0&id=f78711be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78711be",
  null
  
)

export default component.exports